export const HEADER_TOAST_CONTAINER_ID = "header-toast";
//# sourceMappingURL=consts.js.map